<template>
	<div class="animated fadeIn">
		<CTabs  variant="pills" :active-tab="active_tab" @update:activeTab="changeTab" >
			<CTab title="Users"/>
			<CTab title="Create New User" v-if="$store.getters['can']('create-user')"/>
		</CTabs>
		<hr>
		<div>
	        <router-view @activeTab="emitHomeTab($event)">

	        </router-view>
	    </div>
	</div>
</template>
<script>
export default {
	name: 'UserHome',
	data() {
		return {
			active_tab: this.$router.history.current.path.substring(this.$router.history.current.path.lastIndexOf('/') + 1) == 'create' ? 1 : 0,
		}
	},
	methods: {
		changeTab: function(item) {
			this.$router.push(!item ? `/${this.$store.getters.getOrganizationName}/general-access/user` : `/${this.$store.getters.getOrganizationName}/general-access/user/create`)
			this.active_tab = item;
		},
		emitHomeTab: function (value) {
			this.active_tab = value
		}
	}
}
</script>